/**
 * Defines how compatible connection points are.
 */
export var ConnectionPointCompatibilityState;
(function (ConnectionPointCompatibilityState) {
    /** Points are compatibles */
    ConnectionPointCompatibilityState[ConnectionPointCompatibilityState["Compatible"] = 0] = "Compatible";
    /** Points are incompatible because of their types */
    ConnectionPointCompatibilityState[ConnectionPointCompatibilityState["TypeIncompatible"] = 1] = "TypeIncompatible";
    /** Points are incompatible because of their directions */
    ConnectionPointCompatibilityState[ConnectionPointCompatibilityState["DirectionIncompatible"] = 2] = "DirectionIncompatible";
    /** Points are incompatible because they are in the same hierarchy **/
    ConnectionPointCompatibilityState[ConnectionPointCompatibilityState["HierarchyIssue"] = 3] = "HierarchyIssue";
})(ConnectionPointCompatibilityState || (ConnectionPointCompatibilityState = {}));
/**
 * Gets a user friendly message for the given compatibility state.
 * @param state - Defines the compatibility state
 * @returns the message associated with a compatibility state.
 */
export function GetCompatibilityIssueMessage(state) {
    switch (state) {
        case ConnectionPointCompatibilityState.TypeIncompatible:
            return "Cannot connect two different connection types";
        case ConnectionPointCompatibilityState.DirectionIncompatible:
            return "Cannot connect with the same direction";
        case ConnectionPointCompatibilityState.HierarchyIssue:
            return "Source block cannot be connected with one of its ancestors";
        default:
            return "";
    }
}
//# sourceMappingURL=connectionPointCompatibilityState.js.map